import { render, staticRenderFns } from "./ShineSpawner.vue?vue&type=template&id=5e905e7a&scoped=true"
import script from "./ShineSpawner.vue?vue&type=script&lang=js"
export * from "./ShineSpawner.vue?vue&type=script&lang=js"
import style0 from "./ShineSpawner.vue?vue&type=style&index=0&id=5e905e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e905e7a",
  null
  
)

export default component.exports